module.exports = __webpack_public_path__ + "static/media/S3N7-3.da428cf6.svg";